import { DEFAULT_STORE_KEY, DEFAULT_STORE_TYPE } from "./constant";
import { skland } from "./containers";
export var isSkland = skland.isInContainer;
export function checkIsEmpty(data) {
    return Object.keys(data).length === 0;
}
export function isFalse(data) {
    return data === "0" || data === 0 || data === false || data === "false";
}
export function isTrue(data) {
    return data === "1" || data === 1 || data === true || data === "true";
}
export function toBoolean(data) {
    if (isTrue(data)) {
        return true;
    }
    if (isFalse(data)) {
        return false;
    }
    return undefined;
}
export function convert(convertType, value) {
    switch (convertType) {
        case "boolean": {
            if (value === undefined) {
                return undefined;
            }
            if (isTrue(value)) {
                return true;
            }
            if (isFalse(value)) {
                return false;
            }
            return undefined;
        }
        case "number": {
            if (value === undefined || isNaN(+value)) {
                return undefined;
            }
            return +value;
        }
        case "string":
        default:
            return value + "";
    }
}
export function getUrlParams() {
    var params = [];
    var url = new URL(location.href);
    url.searchParams.forEach(function (value, key) {
        params.push({ key: key, value: value });
    });
    return params;
}
export function getHideParamsOptions(options) {
    var isObject = typeof options === "object";
    var storeKey = (isObject && options.storeKey) || DEFAULT_STORE_KEY;
    var storeType = (isObject && options.storeType) || DEFAULT_STORE_TYPE;
    if (storeType &&
        ["localStorage", "sessionStorage"].includes(storeType) === false) {
        throw new Error("adapt sdk's [storeType] should be localStorage or sessionStorage, please check it");
    }
    return { storeKey: storeKey, storeType: storeType };
}
